import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import AuthLayout from '../../Layouts/AuthLayout'

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {

  const { isLoggedIn, user } = useSelector(state => state.auth)

  return isLoggedIn ? (<AuthLayout><RouteComponent /></AuthLayout>) :  <Navigate to="/login" />
  // return <AuthLayout><RouteComponent /></AuthLayout>

}

export default PrivateRoute;